import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  documentsSignContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
    pb: 2.5,
    px: { xs: 0, sm: 2, md: 4 },
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '20px',
  },

  documentsSignHeader: {
    textAlign: 'center',
    paddingBottom: '20px',
  },

  QRCodeContainer: {
    display: 'flex',
    justifyContent: 'center',
  },

  listItem: {
    display: 'list-item',
    pl: 0,
    fontSize: '14px',
  },
};
